// Copyright 2024, Imprivata, Inc.  All rights reserved.

import type { TraceContext } from '@imprivata-cloud/common/types';
import { addSpanAttributes } from '@imprivata-cloud/common';
import type { MemorySection } from './MemorySection';
import type { ComponentData, ComponentId } from '../../agent-api/types';

export class UpdateManagerSection {
  constructor(private readonly _memory: MemorySection) {}

  getComponentInformation(
    workflowId: string,
    _traceContext: TraceContext,
    componentId: ComponentId,
    callback: (data?: ComponentData) => void,
  ) {
    addSpanAttributes({
      get_component_information: {
        workflowId,
        componentId,
      },
    });
    callback(this._memory.agentComponents.get(componentId));
  }
}
